/*
 * OjaOba native bridge  —  v4
 * ---------------------------------------------------------------------------
 * Add to theme.liquid just before </body>:
 *   <script src="{{ 'native-bridge.js' | asset_url }}" defer></script>
 *
 * DIAGNOSTICS: tap the top-left corner of the screen 5 times quickly.
 * The panel now opens EVERYWHERE — normal browser included — so it can report
 * whether the app runtime was detected at all. Previously it sat behind the
 * native check, which made a failed detection look identical to a missing file.
 */
(function () {
  'use strict';

  var VERSION = 'v6';
  var C = window.Capacitor;

  /* ------------------------------------------------------ PLUGIN RESOLUTION */

  // Capacitor.Plugins is populated by the npm plugin wrappers, which only exist
  // in a bundled web app. A remote storefront never loads them, so Plugins can
  // be empty even though the native plugins are compiled into the APK.
  // registerPlugin() is part of the injected runtime and talks to native
  // directly — that is the route that actually works here.
  var _cache = {};
  function plug(name) {
    if (_cache[name] !== undefined) return _cache[name];
    var p = null;
    try {
      if (C && C.Plugins && C.Plugins[name]) p = C.Plugins[name];
      else if (C && typeof C.registerPlugin === 'function') p = C.registerPlugin(name);
    } catch (e) { p = null; }
    _cache[name] = p;
    return p;
  }

  /* ----------------------------------------------------------- DIAGNOSTICS */

  function openDiagnostics() {
    if (document.getElementById('ojaoba-diag')) return;

    var box = document.createElement('div');
    box.id = 'ojaoba-diag';
    box.style.cssText =
      'position:fixed;inset:0;z-index:2147483647;overflow:auto;' +
      'background:#2E1243;color:#F3EEF8;padding:24px 20px 60px;' +
      'font:13px/1.5 -apple-system,Roboto,sans-serif';

    function row(l, v, ok) {
      var c = ok === false ? '#FF8A8A' : ok === true ? '#7FE3A1' : '#EBAE43';
      return '<div style="display:flex;justify-content:space-between;gap:12px;' +
        'padding:8px 0;border-bottom:1px solid #4A2E68"><span style="color:#BFAFD1">' +
        l + '</span><b style="color:' + c + ';text-align:right;word-break:break-all">' +
        v + '</b></div>';
    }
    function btn(id, t) {
      return '<button id="' + id + '" style="width:100%;margin-top:9px;padding:13px;' +
        'background:#EBAE43;color:#2E1243;border:0;border-radius:10px;' +
        'font:700 15px inherit">' + t + '</button>';
    }

    var hasC = !!C;
    var isNat = !!(C && C.isNativePlatform && C.isNativePlatform());
    var keys = [];
    try { keys = C && C.Plugins ? Object.keys(C.Plugins) : []; } catch (e) {}

    box.innerHTML =
      '<h2 style="margin:0 0 4px;font-size:19px">Native diagnostics ' + VERSION + '</h2>' +
      '<p style="margin:0 0 16px;color:#BFAFD1">If the version above is not v6, ' +
      'Shopify is still serving the old file.</p>' +
      row('In-app (user agent)', / OjaObaApp\//.test(navigator.userAgent) ? 'YES' : 'NO',
          / OjaObaApp\//.test(navigator.userAgent)) +
      row('In-app (stored flag)', (function () {
        try { return localStorage.getItem('ojaoba.inapp') ? 'yes' : 'no'; }
        catch (e) { return 'unreadable'; }
      })()) +
      row('Google button hidden', document.querySelector('.in-app') ? 'yes' : 'no',
          !!document.querySelector('.in-app')) +
      '<div style="height:14px"></div>' +
      row('window.Capacitor', hasC ? 'found' : 'MISSING (normal here)', true) +
      row('Native plugins', 'live in the bootstrap page, not here', true) +
      '<p style="margin:14px 0 4px;color:#BFAFD1">Permissions, push and location are ' +
      'handled on the app start-up screen. They cannot be tested from the storefront ' +
      '— that is by design, not a fault.</p>' +
      '<div id="live"></div>' +
      btn('t-reset', 'Reset permission memory') +
      btn('t-close', 'Close');

    document.body.appendChild(box);
    var live = box.querySelector('#live');
    function say(t, ok) { live.innerHTML += row('Result', t, ok); }

    box.querySelector('#t-close').onclick = function () { box.remove(); };

    box.querySelector('#t-reset').onclick = function () {
      try {
        localStorage.removeItem('ojaoba.push.asked');
        localStorage.removeItem('ojaoba.loc.asked');
        localStorage.removeItem('ojaoba.views');
        say('cleared', true);
      } catch (e) { say('failed: ' + e.message, false); }
    };

  }

  // Gesture is registered unconditionally, before any native check, so the
  // panel is reachable even when detection fails.
  var taps = [];
  function cornerTap(x, y) {
    if (x > 70 || y > 70) return;
    var now = Date.now();
    taps.push(now);
    taps = taps.filter(function (t) { return now - t < 3000; });
    if (taps.length >= 5) { taps = []; openDiagnostics(); }
  }
  document.addEventListener('touchstart', function (e) {
    var t = e.touches && e.touches[0];
    if (t) cornerTap(t.clientX, t.clientY);
  }, true);
  document.addEventListener('click', function (e) { cornerTap(e.clientX, e.clientY); }, true);
  if (location.search.indexOf('nativetest=1') > -1) openDiagnostics();

  window.OjaObaDiag = openDiagnostics;
  console.log('[ojaoba] bridge ' + VERSION + ' loaded. Capacitor=' + !!C);

  /* ------------------------------------------------------------ NATIVE ONLY */

  // The storefront is a remote page, so window.Capacitor is NEVER present here
  // — expected, not a fault. Detection is by user agent, which Capacitor stamps
  // into the WebView and which therefore survives redirects and every
  // navigation. Query string and localStorage are only fallbacks.
  var IN_APP = 'ojaoba.inapp';
  var uaMatch = / OjaObaApp\//.test(navigator.userAgent);
  var inApp = uaMatch;
  try {
    if (uaMatch || location.search.indexOf('inapp=1') > -1) localStorage.setItem(IN_APP, '1');
    if (localStorage.getItem(IN_APP)) inApp = true;
  } catch (e) {}
  if (location.search.indexOf('inapp=1') > -1) inApp = true;
  if (C && C.isNativePlatform && C.isNativePlatform()) inApp = true;

  if (!inApp) return;

  var platform = (C && C.getPlatform && C.getPlatform()) || 'app';
  var root = document.documentElement;
  root.classList.add('in-app', 'in-app-' + platform);

  var TOKEN_ENDPOINT = 'https://YOUR-PROJECT.supabase.co/functions/v1/register-device';
  var SUPABASE_ANON_KEY = 'YOUR_ANON_KEY';
  var PUSH_PROMPT = 'launch';        // 'launch' | 'intent'
  var LOCATION_PROMPT = 'launch';    // 'launch' | 'contextual' | 'off'
  var GOOGLE_SIGNIN = 'hide';        // 'hide' | 'warn' | 'allow'
  var PUSH_ASKED = 'ojaoba.push.asked';
  var LOC_ASKED = 'ojaoba.loc.asked';

  /* safe areas + hide app-download promos */
  var css = document.createElement('style');
  css.textContent =
    '.in-app body{padding-top:env(safe-area-inset-top);' +
    'padding-bottom:env(safe-area-inset-bottom)}' +
    '.in-app .app-download-banner,.in-app .smart-app-banner{display:none !important}';
  document.head.appendChild(css);

  /* splash */
  var Splash = plug('SplashScreen');
  function hideSplash() { if (Splash) Splash.hide({ fadeOutDuration: 250 }); }
  if (document.readyState === 'complete') setTimeout(hideSplash, 200);
  else window.addEventListener('load', function () { setTimeout(hideSplash, 200); });

  /* push */
  function asked(k) { try { return !!localStorage.getItem(k); } catch (e) { return false; } }
  function mark(k) { try { localStorage.setItem(k, '1'); } catch (e) {} }

  function registerPush() {
    var Push = plug('PushNotifications');
    if (!Push) return console.warn('[ojaoba] push plugin unavailable');
    mark(PUSH_ASKED);
    try {
      Push.addListener('registration', function (t) {
        fetch(TOKEN_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': SUPABASE_ANON_KEY,
            'Authorization': 'Bearer ' + SUPABASE_ANON_KEY
          },
          body: JSON.stringify({
            token: t.value, platform: platform,
            customer_id: (window.__st && window.__st.cid) || null,
            app_version: VERSION
          })
        }).catch(function () {});
      });
      Push.addListener('pushNotificationActionPerformed', function (a) {
        var u = a && a.notification && a.notification.data && a.notification.data.url;
        if (u) window.location.href = u;
      });
    } catch (e) {}
    Push.requestPermissions().then(function (r) {
      if (r && r.receive === 'granted') Push.register();
    }).catch(function (e) { console.warn('[ojaoba] push request failed', e); });
  }

  if (!asked(PUSH_ASKED)) {
    if (PUSH_PROMPT === 'launch') setTimeout(registerPush, 1500);
    else {
      try {
        var v = parseInt(localStorage.getItem('ojaoba.views') || '0', 10) + 1;
        localStorage.setItem('ojaoba.views', String(v));
        if (v >= 3) registerPush();
      } catch (e) {}
    }
  }

  /* location */
  function requestLocation() {
    var Geo = plug('Geolocation');
    if (!Geo) return console.warn('[ojaoba] geolocation unavailable');
    mark(LOC_ASKED);
    Geo.requestPermissions({ permissions: ['location'] }).catch(function () {});
  }
  window.OjaObaLocation = {
    request: requestLocation,
    current: function () {
      var Geo = plug('Geolocation');
      return Geo ? Geo.getCurrentPosition({ enableHighAccuracy: true, timeout: 10000 })
                 : Promise.reject(new Error('unavailable'));
    }
  };
  if (LOCATION_PROMPT !== 'off' && !asked(LOC_ASKED)) {
    // staggered well clear of the push dialog - stacked permission sheets
    // read as broken and tend to get both denied
    if (LOCATION_PROMPT === 'launch') setTimeout(requestLocation, 5000);
    else if (/\/cart|\/checkout|\/account|address/i.test(location.pathname))
      setTimeout(requestLocation, 800);
  }

  /* google oauth - blocked by Google inside webviews, always 400s */
  if (GOOGLE_SIGNIN !== 'allow') {
    if (GOOGLE_SIGNIN === 'hide') {
      var g = document.createElement('style');
      g.textContent =
        '.in-app a[href*="accounts.google.com"],' +
        '.in-app a[href*="auth/google"],' +
        '.in-app a[href*="google_oauth"],' +
        '.in-app [data-provider="google"],' +
        '.in-app .google-sign-in,.in-app .google-signin-button' +
        '{display:none !important}';
      document.head.appendChild(g);
    }
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href]');
      if (!a || !/accounts\.google\.com|auth\/google|google_oauth/i.test(a.href)) return;
      e.preventDefault(); e.stopPropagation();
      var t = document.createElement('div');
      t.style.cssText =
        'position:fixed;left:16px;right:16px;bottom:26px;z-index:2147483647;' +
        'background:#2E1243;color:#F3EEF8;border:1px solid #4A2E68;border-radius:14px;' +
        'padding:16px 18px;font:14px/1.5 -apple-system,Roboto,sans-serif;' +
        'box-shadow:0 10px 30px rgba(0,0,0,.45)';
      t.innerHTML = '<b style="color:#EBAE43">Google sign-in is not available in the app</b>' +
        '<div style="margin-top:6px;color:#BFAFD1">Google blocks sign-in from inside apps ' +
        'for security. Please sign in with your email address instead.</div>';
      document.body.appendChild(t);
      setTimeout(function () { t.remove(); }, 6000);
    }, true);
  }

  /* back button, network, resume */
  var App = plug('App');
  if (platform === 'android' && App) {
    App.addListener('backButton', function (e) {
      if (e.canGoBack || window.history.length > 1) window.history.back();
      else App.exitApp();
    });
  }
  var Net = plug('Network');
  if (Net) Net.addListener('networkStatusChange', function (s) {
    root.classList.toggle('is-offline', !s.connected);
  });
  if (App) App.addListener('appStateChange', function (s) {
    if (s.isActive && /\/cart|\/checkout/.test(location.pathname)) location.reload();
  });

  console.log('[ojaoba] native features active on ' + platform);
})();